<script setup lang="ts">
const { t } = useI18n()

const menuItems = [
  {
    value: 'journal',
    label: t('journal.title'),
    icon: 'i-mingcute-diary-line',
    to: '/journal'
  },
  {
    value: 'notes',
    label: t('notes.title'),
    icon: 'i-mingcute-sticker-line',
    to: '/notes'
  },
  {
    value: 'lists',
    label: t('lists.title'),
    icon: 'i-mingcute-list-check-line',
    to: '/lists'
  },
  {
    value: 'tasks',
    label: t('tasks.title'),
    icon: 'i-mingcute-checkbox-line',
    to: '/tasks'
  }
]
</script>

<template>
  <nav
    role="navigation"
    class="fixed bottom-0 left-0 right-0 flex gap-2 justify-around items-center px-4 py-4 bg-default/60 z-10 backdrop-blur-xl"
  >
    <ULink
      v-for="item in menuItems"
      :key="item.value"
      as="button"
      color="neutral"
      active-color="primary"
      variant="ghost"
      :to="item.to"
      :aria-label="item.label"
      class="flex flex-col gap-1 items-center justify-center"
    >
      <UIcon :name="item.icon" size="24" />
      <span class="text-xs">{{ item.label }}</span>
    </ULink>
  </nav>
</template>
